import { render, staticRenderFns } from "./sh_NotificationSettings.vue?vue&type=template&id=123691ac&scoped=true&"
import script from "./sh_NotificationSettings.vue?vue&type=script&lang=js&"
export * from "./sh_NotificationSettings.vue?vue&type=script&lang=js&"
import style0 from "./sh_NotificationSettings.vue?vue&type=style&index=0&id=123691ac&prod&lang=css&"
import style1 from "./sh_NotificationSettings.vue?vue&type=style&index=1&id=123691ac&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "123691ac",
  null
  
)

export default component.exports